module.exports = __webpack_public_path__ + "static/5.Risk Disclosure Statement for Futures Trading-b05347465a0c1b90c21b68ca148471ba.pdf";